import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogActions, Typography, Button } from '@mui/material';

import DialogTitle from './components/DialogTitle.js';
import DialogContent from './components/DialogContent.js';

const propTypes = {
	onClose: PropTypes.func,
	onConfirmClicked: PropTypes.func,
	cancelLabel: PropTypes.string,
	confirmLabel: PropTypes.string,
	title: PropTypes.string,
	open: PropTypes.bool,
	modal: PropTypes.bool,
	isDisabled: PropTypes.bool,
	children: PropTypes.object,
	hasConfirm: PropTypes.bool,
	autoScrollBodyContent: PropTypes.bool,
	dialogProps: PropTypes.object,
	maxWidth: PropTypes.string,
	id: PropTypes.string
};

const ModalDialog = (props) => {
	const {
		cancelLabel,
		confirmLabel,
		title,
		open,
		hasConfirm = true,
		onClose,
		children,
		onConfirmClicked,
		isDisabled,
		modal = false,
		autoScrollBodyContent,
		dialogProps,
		maxWidth,
		id = 'confirm_dialog'
	} = props;

	return (
		<Dialog
			open={open}
			aria-labelledby="form-dialog-title"
			fullWidth
			maxWidth={maxWidth ?? 'md'}
			onClose={onClose}
			disableEscapeKeyDown={modal}
			autoScrollBodyContent={autoScrollBodyContent}
			role="dialog"
			{...dialogProps}
		>
			<DialogTitle
				id="form-dialog-title"
				onClose={onClose}
			>
				{title}
			</DialogTitle>
			<DialogContent>
				<Typography component="div">
					{children}
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={onClose}
					variant="text"
					color="inherit"
					id={`cancel_${id}`}
				>
					{cancelLabel || 'Cancel'}
				</Button>
				{
					hasConfirm && (
						<Button
							onClick={onConfirmClicked}
							variant="text"
							color="primary"
							disabled={isDisabled}
							id={`add_${id}`}
						>
							{confirmLabel || 'Apply'}
						</Button>
					)
				}
			</DialogActions>
		</Dialog>
	);
};

ModalDialog.propTypes = propTypes;

export default ModalDialog;
